<template>
  <div class="wrapper">
    <div class="body">
      <div class="row">
        <div class="col-md-12">
          <h4 class="m-0 p-0">Close the loop</h4>
          <p class="text-muted m-0">{{ $t('treatments.pageSubTitle') }}</p>
          <hr />
          <p class="text-black-50 m-0 p-0">
            {{ $t('treatments.filterRullers') }}
            <strong>{{ currentRule }}</strong>
          </p>
        </div>
      </div>
    </div>

    <div
      v-if="notAnswers"
      class="body-content mt-3"
      style="background: #ffffff;"
    >
      <div
        class="row"
        style="
          padding-top: 8%;
          max-width: 1200px;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <div class="col-md-6">
          <h4>Você não possui nenhum cliente para tratativa na regra atual.</h4>
          <br />
          <p v-if="nextSchedulingDate">
            Próximo agendamento: {{ formatDate(nextSchedulingDate) }}
          </p>
          <br />
        </div>

        <div class="col-md-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            width="80%"
            viewBox="0 0 601.6 630"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <rect
              x="756.96373"
              y="195.50659"
              width="1.67162"
              height="109.19622"
              transform="translate(-245.06837 491.48745) rotate(-46.40674)"
              fill="#e6e6e6"
            />
            <polygon
              points="498.845 143.982 497.175 144.083 497.679 152.309 489.437 152.21 489.419 153.882 499.457 154.001 498.845 143.982"
              fill="#e6e6e6"
            />
            <polygon
              points="427.781 76.326 427.763 77.998 419.522 77.899 420.026 86.125 418.355 86.226 417.745 76.206 427.781 76.326"
              fill="#e6e6e6"
            />
            <circle cx="458.59956" cy="115.10464" r="9.19286" fill="#e6e6e6" />
            <rect
              x="389.27378"
              y="249.26889"
              width="109.19622"
              height="1.67162"
              transform="translate(-349.25942 240.03057) rotate(-43.59326)"
              fill="#e6e6e6"
            />
            <polygon
              points="103.815 154.001 113.853 153.882 113.834 152.21 105.593 152.309 106.097 144.083 104.427 143.982 103.815 154.001"
              fill="#e6e6e6"
            />
            <polygon
              points="185.527 76.206 184.916 86.226 183.246 86.125 183.749 77.899 175.508 77.998 175.49 76.326 185.527 76.206"
              fill="#e6e6e6"
            />
            <circle cx="144.67187" cy="115.10464" r="9.19286" fill="#e6e6e6" />
            <path
              d="M669.36429,325.54286H530.63571a7.53,7.53,0,0,1-7.52142-7.52143v-175.5A7.53,7.53,0,0,1,530.63571,135H669.36429a7.53,7.53,0,0,1,7.52142,7.52143v175.5A7.53,7.53,0,0,1,669.36429,325.54286ZM530.63571,136.67143a5.85658,5.85658,0,0,0-5.85,5.85v175.5a5.85658,5.85658,0,0,0,5.85,5.85H669.36429a5.85658,5.85658,0,0,0,5.85-5.85v-175.5a5.85658,5.85658,0,0,0-5.85-5.85Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M588.45985,219.35842h-30.537a3.76488,3.76488,0,0,1-3.76071-3.76071V179.562a3.76488,3.76488,0,0,1,3.76071-3.76071h30.537a3.76489,3.76489,0,0,1,3.76072,3.76071v36.03569A3.76489,3.76489,0,0,1,588.45985,219.35842Z"
              transform="translate(-299.2 -135)"
              fill="#4de594"
            />
            <path
              d="M647.79557,236.07271h-30.537a3.7649,3.7649,0,0,1-3.76072-3.76071V196.27631a3.7649,3.7649,0,0,1,3.76072-3.76072h30.537a3.76489,3.76489,0,0,1,3.76071,3.76072V232.312A3.76489,3.76489,0,0,1,647.79557,236.07271Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M600.15985,287.05128h-30.537a3.76488,3.76488,0,0,1-3.76071-3.76071V247.25488a3.76489,3.76489,0,0,1,3.76071-3.76072h30.537a3.7649,3.7649,0,0,1,3.76072,3.76072v36.03569A3.76489,3.76489,0,0,1,600.15985,287.05128Z"
              transform="translate(-299.2 -135)"
              fill="#ff6584"
            />
            <path
              d="M893.27857,506H754.55a7.53005,7.53005,0,0,1-7.52143-7.52143v-175.5a7.53005,7.53005,0,0,1,7.52143-7.52143H893.27857A7.53,7.53,0,0,1,900.8,322.97857v175.5A7.53,7.53,0,0,1,893.27857,506ZM754.55,317.12857a5.85658,5.85658,0,0,0-5.85,5.85v175.5a5.85658,5.85658,0,0,0,5.85,5.85H893.27857a5.85658,5.85658,0,0,0,5.85-5.85v-175.5a5.85658,5.85658,0,0,0-5.85-5.85Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M847.73214,354.31786H800.09643a3.34286,3.34286,0,0,1,0-6.68572h47.63571a3.34286,3.34286,0,0,1,0,6.68572Z"
              transform="translate(-299.2 -135)"
              fill="#4de594"
            />
            <path
              d="M871.13214,386.075H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,403.625H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,421.175H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,438.725H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,456.275H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M871.13214,473.825H776.69643a3.34286,3.34286,0,1,1,0-6.68571h94.43571a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M445.45,506H306.72143A7.53,7.53,0,0,1,299.2,498.47857v-175.5a7.53,7.53,0,0,1,7.52143-7.52143H445.45a7.53005,7.53005,0,0,1,7.52143,7.52143v175.5A7.53005,7.53005,0,0,1,445.45,506ZM306.72143,317.12857a5.85658,5.85658,0,0,0-5.85,5.85v175.5a5.85658,5.85658,0,0,0,5.85,5.85H445.45a5.85658,5.85658,0,0,0,5.85-5.85v-175.5a5.85658,5.85658,0,0,0-5.85-5.85Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M423.44834,356.89277H381.66263a3.34286,3.34286,0,0,1,0-6.68572h41.78571a3.34286,3.34286,0,1,1,0,6.68572Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M423.44834,374.44277H381.66263a3.34286,3.34286,0,0,1,0-6.68572h41.78571a3.34286,3.34286,0,1,1,0,6.68572Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
            <path
              d="M360.22223,384.43578h-30.537a3.76489,3.76489,0,0,1-3.76072-3.76071V344.63938a3.7649,3.7649,0,0,1,3.76072-3.76072h30.537a3.76489,3.76489,0,0,1,3.76071,3.76072v36.03569A3.76488,3.76488,0,0,1,360.22223,384.43578Z"
              transform="translate(-299.2 -135)"
              fill="#4de594"
            />
            <path
              d="M423.1588,410.37848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M423.1588,427.92848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M423.1588,445.47848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M423.1588,463.02848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M423.1588,480.57848H328.72309a3.34286,3.34286,0,1,1,0-6.68571H423.1588a3.34286,3.34286,0,1,1,0,6.68571Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M497.89518,607.71863V571.68294a3.76489,3.76489,0,0,1,3.76071-3.76071h30.537a3.76489,3.76489,0,0,1,3.76071,3.76071v36.03569a3.7649,3.7649,0,0,1-3.76071,3.76072h-30.537A3.7649,3.7649,0,0,1,497.89518,607.71863Z"
              transform="translate(-299.2 -135)"
              fill="#e6e6e6"
            />
            <path
              d="M508.89518,595.71863V559.68294a3.76489,3.76489,0,0,1,3.76071-3.76071h30.537a3.76489,3.76489,0,0,1,3.76071,3.76071v36.03569a3.7649,3.7649,0,0,1-3.76071,3.76072h-30.537A3.7649,3.7649,0,0,1,508.89518,595.71863Z"
              transform="translate(-299.2 -135)"
              fill="#4de594"
            />
            <path
              d="M645.78429,584.18843a9.07776,9.07776,0,0,1-2.39821-13.71145l-9.4656-69.18787,19.71756.9678,3.09564,67.48557a9.12692,9.12692,0,0,1-10.94939,14.446Z"
              transform="translate(-299.2 -135)"
              fill="#a0616a"
            />
            <path
              d="M656.34418,503.17871a3.70494,3.70494,0,0,1-1.5051,1.06441l-17.71963,6.76294a3.72283,3.72283,0,0,1-4.729-1.96465l-15.69629-35.27523a14.73962,14.73962,0,0,1-.7212-10.43132,14.33679,14.33679,0,0,1,10.91159-9.78216,13.67275,13.67275,0,0,1,5.89.08316,14.27981,14.27981,0,0,1,10.26305,8.92147l13.956,36.89A3.73032,3.73032,0,0,1,656.34418,503.17871Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <polygon
              points="264.807 618.06 252.547 618.06 248.102 570.549 264.809 570.773 264.807 618.06"
              fill="#a0616a"
            />
            <path
              d="M243.79024,614.55666h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H228.90338a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,243.79024,614.55666Z"
              fill="#2f2e41"
            />
            <polygon
              points="321.807 618.06 309.547 618.06 303.715 570.772 321.809 570.773 321.807 618.06"
              fill="#a0616a"
            />
            <path
              d="M300.79024,614.55666h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H285.90338a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,300.79024,614.55666Z"
              fill="#2f2e41"
            />
            <path
              d="M622.54889,736.23552l-19.25513-1.42578a4.50578,4.50578,0,0,1-4.16235-4.27051L594.838,641.80876a3.50008,3.50008,0,0,0-6.92481-.5332L570.002,728.68278a4.50575,4.50575,0,0,1-4.76709,3.582l-17.40576-1.39257a4.4995,4.4995,0,0,1-4.1189-4.93262L559.858,564.46306a4.49952,4.49952,0,0,1,5.43359-3.94922l61.406,13.34863a4.511,4.511,0,0,1,3.543,4.48145L627.38067,731.8322a4.5022,4.5022,0,0,1-4.489,4.416C622.77789,736.24821,622.66363,736.24333,622.54889,736.23552Z"
              transform="translate(-299.2 -135)"
              fill="#2f2e41"
            />
            <circle cx="306.50339" cy="269.88758" r="24.56103" fill="#a0616a" />
            <path
              d="M567.59552,576.9152a21.96161,21.96161,0,0,1-7.2937-16.86621c0-35.30078,30.55566-114.168,31.51367-116.6289.0935-.59278.89966-.84864,5.12939-3.70606,4.23242-2.85937,10.335-3.29883,18.13941-1.30566a4.47911,4.47911,0,0,1,3.25,3.31836l1.4519,2.09765a3.49144,3.49144,0,0,0,2.02881,2.40625c6.29346,2.65137,26.29809,14.87793,19.48144,60.89161-6.33227,42.74316-8.90185,67.88086-9.71264,76.70507a4.49122,4.49122,0,0,1-4.07154,4.06543c-3.08569.27637-8.38183.64356-14.68945.64356C598.20172,588.5363,578.14654,586.56364,567.59552,576.9152Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M538.24736,563.83729a9.07771,9.07771,0,0,1,5.649-12.72182L574.58944,488.39l15.83345,11.79069-35.034,57.76251a9.12692,9.12692,0,0,1-17.14158,5.89414Z"
              transform="translate(-299.2 -135)"
              fill="#a0616a"
            />
            <path
              d="M592.15633,502.454a3.7049,3.7049,0,0,1-1.8429.04517l-18.48219-4.25807a3.72282,3.72282,0,0,1-2.832-4.26646l6.62251-38.03759a14.73969,14.73969,0,0,1,5.21371-9.06366,14.33681,14.33681,0,0,1,14.51142-2.04255,13.67258,13.67258,0,0,1,4.84448,3.35107,14.27983,14.27983,0,0,1,3.55082,13.12686l-8.96734,38.40871A3.7303,3.7303,0,0,1,592.15633,502.454Z"
              transform="translate(-299.2 -135)"
              fill="#ccc"
            />
            <path
              d="M599.95291,427.0789a10.58407,10.58407,0,0,1-2.83917-9.3866c.85636-4.47943,1.35942-7.41039,1.45471-8.47667h0c.32608-3.64766-3.36133-6.60057-7.01009-7.07047-.1414-.01845-.25976-.03074-.35857-.03865.09288.09135.19279.18445.2804.267.693.65084,1.55573,1.46153,1.35064,2.29769-.12362.50327-.58364.86075-1.40663,1.09087-5.70622,1.59678-10.1009.13087-13.83068-4.61645a11.026,11.026,0,0,1-2.10511-4.598c-1.33593-6.5549,2.2239-12.14277,5.4458-15.67537,2.6567-2.91295,6.96354-6.44907,12.39419-6.75209,4.2234-.23583,9.24563,2.19448,10.74888,6.57423a8.15937,8.15937,0,0,1,6.36123-3.58618,14.662,14.662,0,0,1,8.15827,2.26914c11.90914,6.8219,17.02732,23.07258,11.17684,35.48763-3.68038,7.80914-11.65421,13.62273-20.80981,15.17209a10.39312,10.39312,0,0,1-1.7349.14668A10.11515,10.11515,0,0,1,599.95291,427.0789Z"
              transform="translate(-299.2 -135)"
              fill="#2f2e41"
            />
            <path
              d="M484.77874,765h195a1,1,0,0,0,0-2h-195a1,1,0,1,0,0,2Z"
              transform="translate(-299.2 -135)"
              fill="#3f3d56"
            />
          </svg>
        </div>
      </div>
    </div>

    <div class="body-content mt-3" v-if="!notAnswers">
      <div class="header">
        <div class="col-sm">
          <div
            class=""
            style="padding-left: 0; padding-right: 0; margin-top: 24px;"
          >
            <b-button
              class="btn"
              style="
                width: 100px;
                border-radius: 0;
                border: none;
                background: transparent;
              "
              @click="viewType = 'answer'"
              :style="{
                borderBottom:
                  viewType === 'answer' ? '2px solid #4DE594' : 'none',
                color: viewType === 'answer' ? '#4DE594' : '',
              }"
              >Pesquisa</b-button
            >

            <b-button
              class="btn"
              style="
                width: 100px;
                border-radius: 0;
                border: none;
                background: transparent;
              "
              @click="viewType = 'treatment'"
              :style="{
                borderBottom:
                  viewType === 'treatment' ? '2px solid #4DE594' : 'none',
                color: viewType === 'treatment' ? '#4DE594' : '',
              }"
              >Tratativa</b-button
            >

            <b-button
              class="btn"
              style="
                width: 100px;
                border-radius: 0;
                border: none;
                background: transparent;
              "
              @click="viewType = 'research'"
              :style="{
                borderBottom:
                  viewType === 'research' ? '2px solid #4DE594' : 'none',
                color: viewType === 'research' ? '#4DE594' : '',
              }"
              >Responder</b-button
            >
          </div>
        </div>
        <div class="col-sm" v-if="schedulingDate">
          <div
            class="alert alert-warning"
            style="
              background: #fcbe30;
              color: #ffffff;
              font-size: 19px;
              width: auto;
            "
          >
            <font-awesome-icon
              :icon="['fas', 'info-circle']"
              style="font-size: 26px;"
            />
            <i class="fa circle-exclamation"></i>
            {{ $t('treatments.scheduleClient') }}
            {{ formatDate(schedulingDate) }}
          </div>
        </div>
      </div>
      <div class="content">
        <div class="row" v-if="viewType === 'answer'">
          <div class="col-md-6">
            <b-card>
              <template #header>
                <h5 class="mb-0">
                  Informação do cliente
                  <span
                    v-if="answer && answer.metric === 'like-dislike'"
                    class="ml-4 text-muted"
                  >
                    {{ $t('answers.answersDetails.note') }}
                    <span v-if="answer.review === 1">
                      <img
                        alt="Like"
                        width="30"
                        height="30"
                        src="../../../../assets/Like.svg"
                      />
                    </span>
                    <span v-if="answer.review === 0">
                      <img
                        alt="Deslike"
                        width="30"
                        height="30"
                        class="thumbs-down-answer"
                        src="../../../../assets/Deslike.svg"
                      />
                    </span>
                  </span>

                  <span
                    v-if="answer && answer.metric !== 'like-dislike'"
                    class="ml-4 text-muted"
                  >
                    {{ $t('answers.answersDetails.note') }}
                    <b-badge
                      :class="`flag-grade flag-grade-${gradeFormat(
                        answer.review,
                      )}`"
                    >
                      {{ answer.review === 99 ? '-' : answer.review }}
                    </b-badge>
                  </span>

                  <a
                    v-if="answer"
                    href="#"
                    v-b-modal.modal-historic
                    @click="setCostumerTimeline"
                    style="font-weight: normal; color: #7ab4f2;"
                    class="ml-2 pull-right card-link"
                    >Ver histórico</a
                  >
                </h5>
              </template>
              <b-card-text>
                <div class="card-content" v-if="loading">
                  <p>
                    <idx-skeleton width="50" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="100" height="10" radius="6" />
                    </span>
                  </p>
                  <p>
                    <idx-skeleton width="60" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="150" height="10" radius="6" />
                    </span>
                  </p>

                  <p>
                    <idx-skeleton width="70" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="90" height="10" radius="6" />
                    </span>
                  </p>

                  <p>
                    <idx-skeleton width="40" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="80" height="10" radius="6" />
                    </span>
                  </p>

                  <p>
                    <idx-skeleton width="50" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="100" height="10" radius="6" />
                    </span>
                  </p>

                  <p>
                    <idx-skeleton width="70" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="150" height="10" radius="6" />
                    </span>
                  </p>
                </div>
                <div class="card-content" v-if="!loading && answer">
                  <p>
                    Nome:
                    <span class="pull-right">{{
                      checkName(answer.anonymousResponse, answer.name)
                    }}</span>
                  </p>
                  <p>
                    {{ $t('answers.answersDetails.email') }}:<span
                      class="pull-right"
                      >{{
                        checkUserData(
                          answer.anonymousResponse,
                          userProfile.permissions.answers.anonymous_profile,
                          answer.email,
                        )
                      }}</span
                    >
                  </p>
                  <p>
                    {{ $t('answers.answersDetails.phone') }}:<span
                      class="pull-right"
                      >{{
                        checkUserData(
                          answer.anonymousResponse,
                          userProfile.permissions.answers.anonymous_profile,
                          answer.phone,
                        )
                      }}</span
                    >
                  </p>
                  <p>
                    {{ $t('answers.answersDetails.channel') }}:
                    <span class="pull-right">{{
                      !answer.anonymousResponse ? answer.channel : '***********'
                    }}</span>
                  </p>
                  <p>
                    {{ $t('answers.answersDetails.date') }}:<span
                      class="pull-right"
                      >{{ dateFormat(answer.date) }}</span
                    >
                  </p>
                  <p>
                    ControlID:<span class="pull-right">{{
                      answer.controlId
                    }}</span>
                  </p>
                  <p>
                    Ação:
                    <span class="pull-right">{{ answer.actionId.name }}</span>
                  </p>
                </div>
              </b-card-text>
            </b-card>

            <b-card class="mt-3">
              <template #header>
                <h5 class="mb-0">
                  {{ $t('answers.answersDetails.indicators') }}
                </h5>
              </template>
              <b-card-text>
                <div
                  class="card-content text-center text-muted"
                  v-if="answer && answer.indicators.length === 0"
                >
                  <span>{{ $t('answers.answersDetails.none') }}</span>
                </div>
                <div class="card-content" v-if="loading">
                  <div class="row">
                    <idx-skeleton
                      v-for="(indicator, i) of [0, 1, 2, 3]"
                      :key="i"
                      width="100"
                      height="30"
                      radius="15"
                      class="ml-2"
                    />
                  </div>
                </div>
                <div
                  class="card-content"
                  v-if="answer && answer.indicators.length"
                >
                  <b-badge
                    style="padding: 8px; color: #ffffff;"
                    class="mr-2 mb-2"
                    pill
                    v-for="(indicator, i) of answer.indicators"
                    :key="i"
                    >{{
                      indicatorAnonymous(
                        answer.actionId,
                        answer.anonymousResponse,
                        indicator.column,
                        indicator.value,
                        indicator.indicatorId,
                      )
                    }}</b-badge
                  >
                </div>
              </b-card-text>
            </b-card>

            <b-card class="mt-3">
              <template #header>
                <h5 class="mb-0">
                  {{ $t('answers.answersDetails.additionalQuestions') }}
                </h5>
              </template>
              <b-card-text>
                <div class="card-content" v-if="loading">
                  <p>
                    <idx-skeleton width="50" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="100" height="10" radius="6" />
                    </span>
                  </p>
                  <p>
                    <idx-skeleton width="60" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="150" height="10" radius="6" />
                    </span>
                  </p>

                  <p>
                    <idx-skeleton width="70" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="90" height="10" radius="6" />
                    </span>
                  </p>

                  <p>
                    <idx-skeleton width="40" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="180" height="10" radius="6" />
                    </span>
                  </p>

                  <p>
                    <idx-skeleton width="50" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="100" height="10" radius="6" />
                    </span>
                  </p>

                  <p>
                    <idx-skeleton width="70" height="10" radius="6" />
                    <span class="pull-right">
                      <idx-skeleton width="250" height="10" radius="6" />
                    </span>
                  </p>
                </div>
                <div
                  class="card-content text-center text-muted"
                  v-if="answer && answer.additionalQuestions.length === 0"
                >
                  <span>{{ $t('answers.answersDetails.none') }}</span>
                </div>
                <perfect-scrollbar>
                <div id=card-content-format class="card-content">
                  <div class="row" v-if="answer">
                    <div
                      class="col-12"
                      v-for="(item, i) in answer.additionalQuestions"
                      :key="i"
                    >
                      <template
                        v-if="
                          indicatorValuedQuestion(item) &&
                          (!item.conditionalQuestion ||
                            item.conditionalQuestion.includes(
                              conditionalQuestion(),
                            ))
                        "
                      >
                        <like-dislike
                          v-if="item.type === 'LIKE/DISLIKE'"
                          :questionText="item.text"
                          :index="i"
                          :justView="true"
                          :selected="parseInt(item.review)"
                          :hasComment="item.comment"
                          :reviewAnswer="item.review ? item.review : -99"
                          :idQuestion="item._id"
                          :itemId="i.toString()"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <emotion
                          v-if="item.type === 'EMOTION'"
                          :questionText="item.text"
                          :index="i"
                          :justView="true"
                          :itemId="i.toString()"
                          :selected="parseInt(item.review)"
                          :hasComment="item.comment"
                          :reviewAnswer="item.review ? item.review : -99"
                          :idQuestion="item._id"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <likert
                          v-if="item.type === 'LIKERT'"
                          :text="item.text"
                          :itemId="i.toString()"
                          :index="i"
                          :justView="true"
                          :selected="parseInt(item.review)"
                          :hasComment="item.comment"
                          :reviewAnswer="item.review ? item.review : -99"
                          :idQuestion="item._id"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <reviews
                          v-if="item.type === 'REVIEWS'"
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          :justView="true"
                          :selected="parseInt(item.review)"
                          :hasComment="item.comment"
                          :reviewAnswer="item.review ? item.review : -99"
                          :idQuestion="item._id"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <csat
                          v-if="item.type === 'CSAT'"
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          :justView="true"
                          :selected="parseInt(item.review)"
                          :colorTemplate="answer.actionId.email.template.scale"
                          :hasComment="item.comment"
                          :reviewAnswer="item.review ? item.review : -99"
                          :idQuestion="item._id"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <multiple-choices
                          v-if="item.type === 'MULTIPLE'"
                          :type="item.multipleType || ''"
                          :questionText="item.text"
                          :choices="item.multipleValues"
                          :justView="true"
                          :hasComment="item.comment"
                          :idQuestion="item._id"
                          :itemId="i.toString()"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <ces
                          v-if="item.type === 'CES'"
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          :justView="true"
                          :selected="parseInt(item.review)"
                          :colorTemplate="answer.actionId.email.template.scale"
                          :hasComment="item.comment"
                          :reviewAnswer="item.review ? item.review : -99"
                          :idQuestion="item._id"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <likertEmotion
                          v-if="item.type === 'LIKERT/EMOTION'"
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          :justView="true"
                          :selected="parseInt(item.review)"
                          :colorTemplate="answer.actionId.email.template.scale"
                          :hasComment="item.comment"
                          :reviewAnswer="item.review ? item.review : -99"
                          :idQuestion="item._id"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <input-type
                          v-if="item.type === 'INPUT'"
                          :text="item.text"
                          :answerText="item.answerText"
                          :index="i"
                          :justView="true"
                          :idQuestion="item._id"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <label-question
                          v-if="item.type === 'LABEL'"
                          :text="item.text"
                          :idQuestion="item._id"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />

                        <nps
                          v-if="item.type === 'NPS'"
                          :text="item.text"
                          :item-id="i.toString()"
                          :index="i"
                          :justView="true"
                          :selected="parseInt(item.review)"
                          :colorTemplate="answer.actionId.email.template.scale"
                          :hasComment="item.comment"
                          :reviewAnswer="item.review ? item.review : -99"
                          :idQuestion="item._id"
                          :addQuestionTemplate="item.addQuestionTemplate"
                        />
                      </template>
                    </div>
                  </div>
                </div>
                </perfect-scrollbar>
              </b-card-text>
            </b-card>
          </div>

          <div class="col-md-6">
            <b-card>
              <template #header>
                <h5 class="mb-0">
                  {{ $t('answers.answersDetails.comment') }}:
                </h5>
              </template>
              <b-card-text>
                <div class="card-content">
                  <p class="textarea" v-if="loading">
                    <idx-skeleton height="10" radius="6" />
                    <idx-skeleton class="mt-1" height="10" radius="6" />
                    <idx-skeleton
                      class="mt-1"
                      width="150"
                      height="10"
                      radius="6"
                    />
                    <idx-skeleton
                      class="mt-1"
                      width="200"
                      height="10"
                      radius="6"
                    />
                  </p>
                  <div v-if="answer">
                    <template v-if="!answer.anonymousResponse">
                      <p class="textarea" v-if="!loading && answer">
                        {{ answer.feedback }}
                      </p>
                    </template>
                    <template v-else>
                      <p class="textarea">***********</p>
                    </template>
                  </div>
                </div>
              </b-card-text>
            </b-card>

            <b-card class="mt-3">
              <template #header>
                <div class="row">
                  <div class="col-4">
                    <h5 class="mb-0">
                      {{ $t('answers.answersDetails.sentimentAnalyze') }}
                    </h5>
                  </div>
                  <div class="col-8">
                    <h5 class="mb-0">
                      {{ $t('answers.answersDetails.keywords') }}
                    </h5>
                  </div>
                </div>
              </template>
              <b-card-text>
                <div class="card-content" v-if="loading">
                  <div class="row">
                    <div class="col-4 text-center">
                      <idx-skeleton
                        width="45"
                        height="45"
                        radius="100"
                        class="mt-2"
                      />
                      <idx-skeleton
                        width="45"
                        height="15"
                        radius="20"
                        class="mt-2"
                      />
                    </div>
                    <div class="col-8">
                      <div class="row">
                        <idx-skeleton
                          width="50"
                          height="15"
                          radius="10"
                          class="mt-2"
                        />
                        <idx-skeleton
                          width="100"
                          height="15"
                          radius="10"
                          class="mt-2 ml-2"
                        />
                        <idx-skeleton
                          width="50"
                          height="15"
                          radius="10"
                          class="mt-2 ml-2"
                        />
                      </div>
                      <div class="row">
                        <idx-skeleton
                          width="100"
                          height="15"
                          radius="10"
                          class="mt-2"
                        />
                        <idx-skeleton
                          width="60"
                          height="15"
                          radius="10"
                          class="mt-2 ml-2"
                        />
                        <idx-skeleton
                          width="50"
                          height="15"
                          radius="10"
                          class="mt-2 ml-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="card-content"
                  v-if="
                    answer &&
                    answer.sentimentAnalyzeGCP &&
                    (answer.feedback !== '' || answer.feedbackEdited.edition)
                  "
                >
                  <div class="row">
                    <div class="col-4">
                      <div
                        class="row d-flex align-items-center"
                        style="flex-wrap: nowrap;"
                      >
                        <div class="col-4">
                          <img
                            :src="
                              require(`../../../../assets/${getSentiment(
                                answer.sentimentAnalyzeGCP.score,
                              )}.gif`)
                            "
                          />
                          <div>
                            <strong>
                              {{
                                formatScore(answer.sentimentAnalyzeGCP.score)
                              }}
                            </strong>
                          </div>
                        </div>
                        <div class="col-1 text-center" style="font-size: 18px;">
                          =
                        </div>
                        <div class="col-7">
                          <span
                            :class="`flag-sentiment flag-sentiment-${getSentiment(
                              answer.sentimentAnalyzeGCP.score,
                            )}`"
                          >
                            {{
                              formatSentiment(answer.sentimentAnalyzeGCP.score)
                            }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-8">
                      <b-badge
                        style="padding: 8px; color: #ffffff;"
                        class="mr-2 mb-2"
                        pill
                        v-for="(item, i) of answer.sentimentAnalyzeGCP
                          .keyPhrases"
                        :key="i"
                        >{{ item }}</b-badge
                      >
                    </div>
                  </div>

                  <table class="stable" hidden>
                    <tr>
                      <td style="width: 30%;">
                        <img
                          :src="
                            require(`../../../../assets/${getSentiment(
                              answer.sentimentAnalyzeGCP.score,
                            )}.gif`)
                          "
                        />
                        <div style="padding-top: 10px;">
                          <strong>
                            {{ formatScore(answer.sentimentAnalyzeGCP.score) }}
                          </strong>
                        </div>
                      </td>
                      <td style="width: 5%;">
                        <span style="font-size: 30px;"> = </span>
                      </td>
                      <td style="width: 65%;">
                        <span
                          :class="`flag-sentiment flag-sentiment-${getSentiment(
                            answer.sentimentAnalyzeGCP.score,
                          )}`"
                        >
                          {{
                            formatSentiment(answer.sentimentAnalyzeGCP.score)
                          }}
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>
              </b-card-text>
            </b-card>

            <b-card class="mt-3">
              <template #header>
                <h5 class="mb-0">Categorias de entrada</h5>
              </template>
              <b-card-text>
                <div class="card-content">
                  <div v-if="answer">
                    <p class="mb-0">Categorias de entrada</p>

                    <div class="input-category">
                      <b-badge
                        class="m-1 p-2"
                        variant="secondary text-white"
                        v-for="(category, i) in answer.categories"
                        :key="i"
                      >
                        {{ category.name }}
                        <span
                          class="closebtn"
                          @click="handleRemoveCategory(category._id, i)"
                          >&times;</span
                        >
                      </b-badge>
                      <add-treatment-categories
                        v-if="userProfile.permissions.treatments.category"
                        :id-item="`${answer._id}`"
                        :categories="answer.categories"
                        :categoryGroupId="answer.actionId.categoryGroupId"
                        :myAnswer="answer"
                        :subCategory="answer.subCategories"
                      />
                    </div>

                    <div
                      v-for="(category, i) in answer.categories"
                      class="mt-3"
                      :key="i"
                    >
                      <p class="mt-3 mb-0">Subcategoria {{ category.name }}</p>

                      <div class="input-category">
                        <b-badge
                          style="background: #7ab4f2;"
                          class="m-1 p-2"
                          variant="info text-white"
                          v-for="(subCategory,
                          index) in answer.subCategories.filter(
                            (item) => item.mainCategoryId === category._id,
                          )"
                          :key="subCategory._id"
                        >
                          {{ subCategory.name }}
                          <span
                            class="closebtn"
                            @click="
                              handleRemoveSubCategory(
                                category._id,
                                subCategory._id,
                                index,
                              )
                            "
                            >&times;</span
                          >
                        </b-badge>
                        <add-treatment-categories
                          v-if="userProfile.permissions.treatments.category"
                          :mainCategoryId="category._id"
                          :id-item="`${answer._id}`"
                          :categories="answer.categories"
                          :categoryGroupId="answer.actionId.categoryGroupId"
                          :myAnswer="answer"
                          :subCategory="answer.subCategories"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </div>
        <!-- row answer -->

        <div class="row" v-if="viewType === 'treatment'">
          <div class="col-6">
            <b-card v-if="userProfile.permissions.treatments.enableResponsible">
              <template #header>
                <h5 class="mb-0">Status da tratativa</h5>
              </template>

              <div class="card-content">
                <div class="row">
                  <div class="col-6">
                    <p class="mb-0">
                      {{ $t('answers.answersDetails.treatments.responsible') }}:
                    </p>
                    <b-form-select
                      v-model="myResponsible"
                      :responsible="myResponsible"
                      :options="users"
                    >
                    </b-form-select>
                  </div>

                  <div class="col-6">
                    <p class="mb-0">Status da tratativa</p>
                    <b-form-select v-model="myStatus" :options="status">
                    </b-form-select>
                  </div>
                </div>
              </div>
            </b-card>

            <b-card class="mt-3">
              <template #header>
                <h5 class="mb-0">
                  Registro de contato
                  <!-- <span class="custom-switch pull-right">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="switch-monitor"
                      v-model="answer.treatments.enableMonitor"
                    />
                    <label
                      class="custom-control-label"
                      for="switch-monitor"
                    ></label>
                  </span> -->
                </h5>
              </template>

              <div class="card-content">
                <div class="row">
                  <div class="col-6">
                    <p class="mb-0">Canal de comunicação:</p>
                    <b-form-select
                      :options="channelOptions"
                      v-model="monitorTreatment.channel"
                    >
                    </b-form-select>
                  </div>

                  <div class="col-6">
                    <p class="mb-0">Status:</p>
                    <b-form-select
                      :options="statusOptions"
                      v-model="monitorTreatment.status"
                    >
                    </b-form-select>
                  </div>
                </div>

                <!-- <div class="row mt-2">
                  <div class="col-6">
                    <p class="mb-0">
                      Tentativa:
                    </p>
                    <b-form-select
                      :options="tryOptions"
                      v-model="monitorTreatment.attempts"
                    >
                    </b-form-select>
                  </div>

                  <div class="col-6"></div>
                </div> -->

                <div
                  class="row mt-2"
                  v-if="
                    monitorTreatment.status === 'Não atendida' ||
                    monitorTreatment.status === 'Retornar para cliente' ||
                    monitorTreatment.status === 'Em acompanhamento'
                  "
                >
                  <div class="col-6">
                    <p class="mb-0">Data da próxima tratativa:</p>
                    <b-form-input
                      type="date"
                      v-model="monitorTreatment.date"
                      :min="minDate"
                    ></b-form-input>
                  </div>

                  <div class="col-6">
                    <p class="mb-0">Horário da próxima tratativa:</p>
                    <b-form-input
                      type="time"
                      v-model="monitorTreatment.time"
                      :min="minTime"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </b-card>

            <b-card class="mt-3">
              <template #header>
                <h5 class="mb-0">Adicionar comentário</h5>
              </template>

              <div class="card-content">
                <div
                  v-if="userProfile.permissions.treatments.enableComment"
                  class="comment-area"
                >
                  <textarea class="form-control" rows="3" v-model="myComment" />
                </div>
                <!-- Enables if the company has upload permission in the negotiation (config master) and if the user is allowed to view (config user permission) -->
                <div
                  class="mt-2 file-custom"
                  v-if="
                    enabledAttach &&
                    userProfile.permissions.treatments.enableAttachment
                  "
                >
                  <b-list-group class="mb-2">
                    <b-list-group-item
                      v-for="(item, index) in filesToUpload"
                      :key="item.name"
                    >
                      <font-awesome-icon
                        style="color: #777777;"
                        :icon="['fas', 'paperclip']"
                      />
                      {{ item.name.substring(0, 40) + '...' }}
                      <font-awesome-icon
                        class="float-right"
                        style="color: red;"
                        @click="removeFile(index)"
                        :icon="['fas', 'times-circle']"
                      />
                    </b-list-group-item>
                  </b-list-group>
                  <div class="text-center" v-if="isLoading">
                    <b-spinner variant="primary" label=""></b-spinner>
                  </div>
                  <p class="mb-0" v-if="!isLoading">
                    {{ $t('uploads.attachFile') }}:
                  </p>
                  <b-form-file
                    v-if="!isLoading"
                    multiple
                    :placeholder="$t('uploads.selectLabel')"
                    :browse-text="$t('uploads.selectLabel')"
                    :drop-placeholder="$t('uploads.dropPlaceholder')"
                    id="selectFile"
                    ref="fileupload"
                    v-model="filesToUpload"
                  >
                  </b-form-file>
                  <p class="mt-3" style="color: #bdbdbd; font-size: 12px;">
                    Permitido usar imagem, vídeo e áudio de até 10MB. Use um
                    arquivo no formato *png, *jpeg *jpg *mp3 *mp4.
                  </p>
                </div>
              </div>
            </b-card>
          </div>

          <div class="col-6">
            <b-card>
              <template #header>
                <h5 class="mb-0">Categorias de saída</h5>
              </template>

              <b-card-text>
                <div class="card-content">
                  <div v-if="answer">
                    <p class="mb-0">Categorias de saída</p>

                    <div class="input-category">
                      <b-badge
                        class="m-1 p-2"
                        variant="secondary text-white"
                        v-for="(subtag, i) in answer.tags"
                        :key="i"
                      >
                        {{ subtag.name }}
                        <span
                          class="closebtn"
                          @click="handleRemoveTag(subtag._id, i)"
                          >&times;</span
                        >
                      </b-badge>
                      <add-treatment-tags
                        v-if="userProfile.permissions.treatments.category"
                        :id-item="`${answer._id}`"
                        :tags="answer.tags"
                        :tagGroupId="answer.actionId.tagGroupId"
                        :myAnswer="answer"
                        :subTags="answer.subTags"
                      />
                    </div>

                    <div v-for="(tag, i) in answer.tags" class="mt-3" :key="i">
                      <p class="mt-3 mb-0">Subcategoria {{ tag.name }}</p>

                      <div class="input-category">
                        <b-badge
                          style="background: #7ab4f2;"
                          class="m-1 p-2"
                          variant="info text-white"
                          v-for="(subTag, index) in answer.subTags.filter(
                            (item) => item.mainTagId === tag._id,
                          )"
                          :key="subTag._id"
                        >
                          {{ subTag.name }}
                          <span
                            class="closebtn"
                            @click="
                              handleRemoveSubTag(tag._id, subTag._id, index)
                            "
                            >&times;</span
                          >
                        </b-badge>
                        <add-treatment-tags
                          v-if="userProfile.permissions.treatments.category"
                          :mainTagId="tag._id"
                          :id-item="`${answer._id}`"
                          :tags="answer.tags"
                          :tagGroupId="answer.actionId.categoryGroupId"
                          :myAnswer="answer"
                          :subTags="answer.subTags"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-text>
            </b-card>

            <b-card class="mt-3">
              <template #header>
                <h5 class="mb-0">Feed</h5>
              </template>

              <div class="card-content">
                <feed-item :items="costumerNotifications" />
              </div>
            </b-card>
          </div>
          <div class="col-12 text-right mt-4">
            <b-button
              class="custom-primary"
              variant="outline-primary"
              @click="nextTreatment"
              :disabled="isReloading"
              >Próxima tratativa</b-button
            >
            <b-button @click="saveTreatment" class="btn btn-primary"
              >Salvar tratativa</b-button
            >
          </div>
        </div>
        <!-- row treatments-->

        <div class="row" v-if="viewType === 'research'">
          <div class="col-6">
            <b-card>
              <template #header>
                <h5 class="mb-0">E-mail</h5>
              </template>

              <div class="card-content">
                <div class="row">
                  <div class="col-12">
                    <p class="mb-0">
                      {{ this.$t('answers.answersDetails.treatments.to') }}
                    </p>
                    <template
                      v-if="userProfile.permissions.answers.anonymous_profile"
                      ><input
                        value="***************"
                        class="form-control"
                        :disabled="this.habilitFields"
                    /></template>
                    <template v-else>
                      <input
                        v-model="toEmail"
                        class="form-control"
                        :disabled="this.habilitFields"
                      />
                    </template>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-6">
                    <p class="mb-0">
                      {{ this.$t('answers.answersDetails.treatments.subject') }}
                    </p>
                    <input
                      v-model="emailSubject"
                      class="form-control"
                      :disabled="this.habilitFields"
                    />
                  </div>
                  <div class="col-6">
                    <p class="mb-0">
                      {{ this.$t('answers.answersDetails.treatments.from') }}
                    </p>
                    <input
                      v-model="emailSender"
                      class="form-control"
                      :disabled="this.habilitFields"
                    />
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-12">
                    <p class="mb-0">
                      {{
                        this.$t('answers.answersDetails.treatments.template')
                      }}
                    </p>
                    <b-form-select
                      class="form-control"
                      @change="handleTemplateSelected"
                      v-model="templateSelected"
                      :options="templateOptionsLean"
                    ></b-form-select>
                  </div>
                </div>

                <div class="mt-3">
                  <wysiwyg
                    api-key="no-api-key"
                    license_key="gpl2"
                    tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
                    :disabled="this.habilitFields"
                    v-model="emailText"
                    :init="{
                      menubar: false,
                      statusbar: false,
                      height: 400,
                      language: $t('newAction.stepOne.editorLanguage'),
                      plugins: 'link image lists hr emoticons',
                      toolbar:
                        'bold italic underline | alignleft aligncenter alignright alignjustify | link image | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | code',
                      lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                      font_formats:
                        'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                      image_description: false,
                      image_title: false,
                      content_style: 'img {max-width: 100%; max-height: 100%}',
                      image_dimensions: false,
                      file_picker_types: 'image',
                      images_upload_handler: imagesUploadHandlerBody,
                    }"
                  />
                </div>
                <div class="row mt-3">
                  <div class="col-12">
                    <p class="mb-0">
                      {{ $t('closetheloop.configureTemplate.saveTemplate') }}
                    </p>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        id="input-template"
                        :placeholder="
                          $t(
                            'closetheloop.configureTemplate.saveTemplatePlaceholder',
                          )
                        "
                        v-model="newTemplateName"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-primary"
                          @click="handleSaveTemplate"
                        >
                          {{ $t('closetheloop.configureTemplate.saveButton') }}
                        </button>
                        <button
                          class="btn btn-outline-secondary"
                          id="update-template"
                          :disabled="disabled"
                          @click="updateTemplate"
                        >
                          {{
                            this.$t(
                              'answers.answersDetails.treatments.updateTemplate',
                            )
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </div>

          <div class="col-6">
            <b-card>
              <template #header>
                <h5 class="mb-0">
                  <span>
                    <i
                      style="
                        color: #4ce595;
                        cursor: pointer;
                        font-size: 25px;
                        margin-bottom: 15px;
                      "
                      class="fas fa-sync-alt"
                      @click="refresh()"
                      title="Refresh"
                    ></i>
                  </span>
                  Feed
                </h5>
              </template>

              <div class="card-content">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12">
                      <ul class="message timeline">
                        <li
                          v-for="(allAnswersEmail, index) in allAnswers"
                          :key="index"
                          class="timeline-item bg-white rounded ml-3 p-4 shadow"
                        >
                          <div
                            class="position-share"
                            v-if="allAnswers[index].type === 'inbound'"
                          >
                            <i
                              @click="replyEmail"
                              class="fa fa-share"
                              style="cursor: pointer;"
                            ></i>
                          </div>

                          <div class="timeline-arrow" />

                          <p
                            style="
                              font-size: 12px;
                              color: #000;
                              padding-bottom: 10px;
                            "
                            class="h5 mb-0"
                          >
                            <strong>De:</strong>
                            {{ allAnswers[index].message.from }}
                          </p>

                          <p
                            style="font-size: 12px; padding-bottom: 10px;"
                            class="h5 mb-0"
                            v-if="allAnswers[index].message.to"
                          >
                            <strong>Para:</strong>
                            {{ allAnswers[index].message.to }}
                          </p>

                          <p
                            style="font-size: 12px; padding-bottom: 10px;"
                            class="h5 mb-0"
                          >
                            <strong>Assunto</strong>:
                            {{ allAnswers[index].message.subject }}
                          </p>

                          <p class="small text-gray">
                            {{ allAnswers[index].date }}
                          </p>

                          <template v-if="allAnswers[index].type === 'inbound'">
                            <span
                              id="messageText"
                              name="messageText"
                              v-html="allAnswers[index].message.html"
                            >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              id="messageText"
                              name="messageText"
                              v-html="allAnswers[index].message.text"
                            >
                            </span
                          ></template>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <feed-item style="display: none;" />
              </div>
            </b-card>
          </div>

          <div class="col-12 text-right mt-4">
            <b-button
              class="custom-primary"
              variant="outline-primary"
              @click="nextTreatment"
              :disabled="isReloading"
              >Próxima tratativa</b-button
            >
            <b-button
              @click="sendMail"
              :disabled="this.habilitFields"
              class="btn btn-primary"
              >Enviar</b-button
            >
          </div>
        </div>
        <!-- row research -->
      </div>
    </div>

    <b-modal
      v-if="answer"
      id="modal-historic"
      size="lg"
      scrollable
      ok-only
      ok-title="Fechar"
      :title="`${$t('answers.answersDetails.historic')} ${getFirstName(
        answer.anonymousResponse,
        answer.name,
      )}`"
    >
      <div class="row time-line d-flex justify-content-center mt-70 mb-70">
        <div class="col-12">
          <div class="main-card mb-3">
            <div v-if="loadingTimeline">
              <idx-skeleton hight="25" radius="16" class="mt-2" />
              <idx-skeleton hight="25" radius="16" width="70" class="mt-2" />
              <br />
              <idx-skeleton hight="25" radius="16" class="mt-2" />
              <idx-skeleton hight="25" radius="16" width="70" class="mt-2" />
              <br />
              <idx-skeleton hight="25" radius="16" class="mt-2" />
              <idx-skeleton hight="25" radius="16" width="70" class="mt-2" />
              <br />
              <idx-skeleton hight="25" radius="16" class="mt-2" />
              <idx-skeleton hight="25" radius="16" width="70" class="mt-2" />
              <br />
            </div>
            <div class="card-body" v-if="items.length && !loadingTimeline">
              <div
                class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
              >
                <div
                  class="vertical-timeline-item vertical-timeline-element"
                  v-for="(item, i) in items"
                  :key="i"
                >
                  <div>
                    <span class="vertical-timeline-element-icon bounce-in">
                      <i
                        class="badge badge-dot badge-dot-xl"
                        :style="{ background: item.color }"
                      >
                        .
                      </i>
                    </span>
                    <div class="vertical-timeline-element-content bounce-in">
                      <h4 class="timeline-title">
                        {{ $t('answers.answersDetails.note') }}:
                        {{
                          !answer.anonymousResponse
                            ? item.content.review === 99
                              ? '-'
                              : item.content.review
                            : '**********'
                        }}
                      </h4>
                      <p class="text-muted">
                        {{ $t('answers.answersDetails.action') }}:
                        <template v-if="!answer.anonymousResponse">
                          <strong>{{
                            item.content.action ? item.content.action.name : '-'
                          }}</strong>
                        </template>
                        <template v-else>***********</template>
                        {{ $t('answers.answersDetails.channel') }}:
                        <strong>{{
                          !answer.anonymousResponse
                            ? item.content.channel
                            : '***********'
                        }}</strong>
                      </p>
                      <p class="timeline-textarea">
                        <template v-if="!answer.anonymousResponse">
                          {{
                            item.content.feedback ? item.content.feedback : '-'
                          }}
                        </template>
                        <template v-else>***********</template>
                      </p>
                      <p class="mb-0">
                        {{ item.content.branch ? item.content.branch : '' }}
                      </p>
                      <template v-if="!answer.anonymousResponse">
                        <a
                          target="_blank"
                          :href="`treatments/${item.content.answerId}`"
                        >
                          <i class="fas fa-search"></i>
                          Visualizar Pesquisa
                        </a>
                      </template>
                      <span class="vertical-timeline-element-date">{{
                        item.content.tag
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import swal from 'sweetalert';
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import treatmentTable from '@/components/molecules/treatment-table';
import treatmentOverview from '@/components/molecules/treatment-overview';
import dashboardBar from '@/components/molecules/dashboard-bar';
import likeDislike from '@/components/molecules/metrics/like-dislike';
import emotion from '@/components/molecules/metrics/emotion';
import likert from '@/components/molecules/metrics/likert';
import reviews from '@/components/molecules/metrics/reviews';
import csat from '@/components/molecules/metrics/csat';
import nps from '@/components/molecules/metrics/nps';
import ces from '@/components/molecules/metrics/ces';
import multipleChoices from '@/components/molecules/metrics/multiple-choices';
import inputType from '@/components/molecules/metrics/input-type';
import likertEmotion from '@/components/molecules/metrics/likert-emotion';
import labelQuestion from '@/components/molecules/metrics/label-question';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import FeedItem from '@/components/molecules/treatment-feed-item';
import addTreatmentCategories from '@/components/molecules/add-treatment-categories';
import addTreatmentTags from '@/components/molecules/add-treatment-tags';
import { lightFormat, format } from 'date-fns';
import * as moment from 'moment';
import api from '../../../../services/api';
import EventBus from '../../../../eventBus';

import Vue from 'vue';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

Vue.use(PerfectScrollbar);

export default {
  components: {
    treatmentTable,
    treatmentOverview,
    dashboardBar,
    idxSkeleton,
    likeDislike,
    emotion,
    likert,
    reviews,
    csat,
    nps,
    multipleChoices,
    inputType,
    labelQuestion,
    ces,
    FeedItem,
    addTreatmentCategories,
    addTreatmentTags,
    likertEmotion,
  },

  computed: {
    ...mapState('treatments', ['costumerNotifications', 'oneAnswer']),
    ...mapState('authentication', ['userProfile']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapFields('branches', ['ih1']),
    templateOptionsLean() {
      return this.templateOptions.map((el) => ({
        value: el.value,
        text: el.text,
      }));
    },
  },
  data: () => ({
    notAnswers: false,
    nextSchedulingDate: null,
    loading: false,
    isReloading: false,
    loadingTimeline: false,
    userAuth: null,
    viewType: 'answer',
    answer: null,
    answerId: null,
    schedulingDate: null,
    currentRule: null,
    minDate: moment().format('YYYY-MM-DD'),
    minTime: moment().format('HH:mm'),
    myMetric: null,
    indicatorsAction: [],
    items: [],
    enabledAttach: false,
    filesToUpload: [],
    isLoading: false,
    myStatus: null,
    status: [],
    myResponsible: null,
    myComment: null,
    additionalFields: [
      {
        name: 'Número da peça',
        value1: null,
        value2: null,
        value3: null,
      },
      {
        name: 'Nome da peça',
        value1: null,
        value2: null,
        value3: null,
      },
      {
        name: 'Preço',
        value1: null,
        value2: null,
        value3: null,
      },
    ],
    contactClient: false,
    contactMode: null,
    disabledContactMode: false,
    users: [{ value: 'none', text: 'Ninguém' }],
    options: [],
    tagSearch: '',
    loadingSub: false,
    answerTags: [],
    profiles: [],
    userType: null,
    toEmail: [],
    habilitFields: false,
    emailSubject: 'Retorno Equipe Experiência do Cliente',
    emailText: '',
    emailSender: null,
    historicMessage: ' ',
    historicFrom: null,
    historicSubject: null,
    historicTo: null,
    historicDate: null,
    allAnswers: [],
    templateSelected: null,
    templateOptions: [],
    templateNameSelected: null,
    newTemplateName: null,
    disabled: true,
    statusOptions: [
      { value: 'Não atendida', text: 'Não atendida' },
      {
        value: 'Número pertence a outra pessoa',
        text: 'Número pertence a outra pessoa',
      },
      {
        value: 'Impossível completar a chamada',
        text: 'Impossível completar a chamada',
      },
      { value: 'Tratado', text: 'Tratado' },
      { value: 'Retornar para cliente', text: 'Retornar para cliente' },
      { value: 'Em acompanhamento', text: 'Em acompanhamento' },
      { value: 'Problema não resolvido', text: 'Problema não resolvido' },
      { value: 'Finalizado', text: 'Finalizado' },
    ],
    channelOptions: [
      { value: 'Telefone', text: 'Telefone' },
      { value: 'E-mail', text: 'E-mail' },
      { value: 'Não se Aplica', text: 'Não se Aplica' },
    ],
    monitorTreatment: {
      channel: 'Telefone',
      status: null,
      attempts: null,
      date: null,
      time: null,
    },
    tryOptions: [
      { value: '1ª tentativa de 4', text: '1ª tentativa de 4' },
      { value: '2ª tentativa de 4', text: '2ª tentativa de 4' },
      { value: '3ª tentativa de 4', text: '3ª tentativa de 4' },
      { value: '4ª tentativa de 4', text: '4ª tentativa de 4' },
    ],
    promotersGrades: [5, 4],
    passivesGrades: [3],
    detractorsGrades: [2, 1],
  }),
  watch: {
    'monitorTreatment.channel': function watchMonitorTreatment(value) {
      if (value === 'Não se Aplica') {
        this.statusOptions = [
          { value: 'Fechado - RNEG', text: 'Fechado - RNEG' },
          { value: 'Fechado - Anônimo', text: 'Fechado - Anônimo' },
          { value: 'Comentário Inválido', text: 'Comentário Inválido' },
          { value: 'Cliente Não Quer Contato', text: 'Cliente Não Quer Contato' },
        ];
      } else {
        this.statusOptions = [
          { value: 'Não atendida', text: 'Não atendida' },
          {
            value: 'Número pertence a outra pessoa',
            text: 'Número pertence a outra pessoa',
          },
          {
            value: 'Impossível completar a chamada',
            text: 'Impossível completar a chamada',
          },
          { value: 'Tratado', text: 'Tratado' },
          { value: 'Retornar para cliente', text: 'Retornar para cliente' },
          { value: 'Em acompanhamento', text: 'Em acompanhamento' },
          { value: 'Problema não resolvido', text: 'Problema não resolvido' },
          { value: 'Finalizado', text: 'Finalizado' },
        ];
      }
    },
  },
  methods: {
    ...mapActions('treatments', [
      'setCostumerNotifications',
      'updateStatus',
      'updateStatusSinqia',
      'updateEnableMonitor',
      'setOneAnswer',
      'addComment',
      'updateResponsible',
    ]),
    ...mapActions('settings', ['getAllUsers']),
    // async startTimer(){
    //   this.timer = setTimeout(()=>{
    //     api.put(`/treatments/disable-treatment/${this.answerId}`, {
    //     callWorking:false
    //   },
    //   {
    //     headers: {
    //       'x-access-token': this.userAuth.token,
    //     },
    //   })

    //  this.$bvModal.msgBoxOk('O tempo limite foi exedido, esta tratativa voltará para a fila.', {
    //     title: 'Atenção!',
    //     okTitle: 'Ok',
    //     okVariant: 'danger',
    //     footerClass: 'p-2',
    //     centered: true
    //   });

    //   setTimeout(()=>{
    //     this.answerId = null;
    //     this.$router.push('/dashboard');
    //   }, 3000)

    //   }, 300000)
    // },

    cancelTimer(){
      clearTimeout(this.timer);
    },
    formatDate(date) {
      return moment(date).add(3, 'hours').format('DD/MM/YYYY HH:mm');
    },
    async reloadAnswer() {
      if (this.answerId) {
        this.isReloading = true;
        const resp = await api.get(
          `${process.env.API_ROOT}/answer/${this.userAuth.companyId}/${this.answerId}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
        this.answer = resp.data;
        this.isReloading = false;
      }
    },
    async nextTreatment() {
      // pegar último status de tratativa em notifications
      // verificar se este status é do tipo agendamendo => [monitorTreatment.status === 'Não atendida','Retornar para cliente','Em acompanhamento'
      // verificar se existe agendamento com data futura
      // se sim, next
      // se não exibe mensagem para reagendar

      // verificar se status === Respondido
      if (this.answer.treatments.status === 'respondido') {
        // next
        this.loadTreatment();
      } else {
        const notifications = this.answer.treatments.notifications;

        if (notifications && notifications.length) {
          const hasNA = notifications.filter(
            (item) =>
              item.type === 'status-treatment' &&
              (item.change === 'Fechado - RNEG' ||
                item.change === 'Fechado - Anônimo' ||
                item.change === 'Cliente Não Quer Contato' ||
                item.change === 'Comentário Inválido'),
          );

          if (hasNA && hasNA.length) {
            this.loadTreatment();
            return;
          }

          const hasScheduling = notifications.filter(
            (item) => item.type === 'status-treatment' && item.schedulingDate,
          );
          if (hasScheduling.length) {
            const lastScheduling = hasScheduling[hasScheduling.length - 1];
            // verificar se schedulingDate é menor que a data/hora atual

            const diff = moment(moment(), 'DD/MM/YYYY HH:mm').diff(
              moment(
                moment(lastScheduling.schedulingDate).add(3, 'hours'),
                'DD/MM/YYYY HH:mm',
              ),
            );

            if (diff < 0) {
              // next treatment
              this.loadTreatment();
            } else {
              // no next has past scheduling
              swal({
                title: 'Ação não pode ser realizada',
                text:
                  'Para ir para a próxima tratativa, altere informações ou agende.',
                icon: 'error',
              });
            }
          } else {
            // no next- no has scheduling
            swal({
              title: 'Ação não pode ser realizada',
              text:
                'Para ir para a próxima tratativa, altere informações ou agende.',
              icon: 'error',
            });
          }
        } else {
          // no text no has notifications
          swal({
            title: 'Ação não pode ser realizada',
            text:
              'Para ir para a próxima tratativa, altere informações ou agende.',
            icon: 'error',
          });
        }
      }
    },
    async saveTreatment() {
      if (
        this.myStatus ||
        this.myResponsible ||
        this.monitorTreatment.status ||
        this.myComment ||
        this.filesToUpload.length
      ) {
        this.isReloading = true;
        if (this.filesToUpload.length) {
          if (
            this.filesToUpload.filter((item) => item.size > 10000000).length
          ) {
            swal({
              title: this.$t(
                'answers.answersDetails.treatments.swAddError.title',
              ),
              text:
                'Um ou mais arquivos excedem o limite. O tamanho máximo permitido é 10Mb',
              icon: 'error',
            });
            this.$refs.fileupload.reset();
          } else {
            this.isLoading = true;

            const fileLinks = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const file of this.filesToUpload) {
              const formData = new FormData();
              formData.append('file', file);
              // eslint-disable-next-line no-await-in-loop
              const link = await api.post('treatments/attachments', formData, {
                headers: {
                  'x-access-token': this.userAuth.token,
                  'Content-Type': 'multipart/form-data',
                },
              });
              fileLinks.push(link.data);
            }

            this.isLoading = false;
            await this.addComment({
              token: this.userAuth.token,
              answerId: this.answer._id,
              data: {
                comment: this.myComment || '',
                attachments: fileLinks,
              },
            });

            this.myComment = null;

            this.setCostumerNotifications({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
              answerId: this.answer._id,
            });
            this.filesToUpload = [];
          }
        } else if (
          this.myComment &&
          this.myComment !== '' &&
          this.myComment != null
        ) {
          await this.addComment({
            token: this.userAuth.token,
            answerId: this.answer._id,
            data: { comment: this.myComment },
          });

          this.myComment = null;

          this.setCostumerNotifications({
            token: this.userAuth.token,
            companyId: this.userAuth.companyId,
            answerId: this.answer._id,
          });
        }

        // changeResponsible
        if (this.answer.treatments.responsible) {
          if (
            this.myResponsible &&
            this.myResponsible !== this.answer.treatments.responsible
          ) {
            this.updateResponsible({
              token: this.userAuth.token,
              answerId: this.answer._id,
              data: { responsible: this.myResponsible },
            }).then(() => {
              this.answer.treatments.responsible = this.myResponsible;

              this.setCostumerNotifications({
                token: this.userAuth.token,
                companyId: this.userAuth.companyId,
                answerId: this.answer._id,
              });
            });
          }
        } else if (this.myResponsible) {
          this.updateResponsible({
            token: this.userAuth.token,
            answerId: this.answer._id,
            data: { responsible: this.myResponsible },
          }).then(() => {
            this.answer.treatments.responsible = this.myResponsible;

            this.setCostumerNotifications({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
              answerId: this.answer._id,
            });
          });
        }
        // changeStatus
        if (this.myStatus && this.myStatus !== this.answer.treatments.status) {
          this.changeStatus();
        }

        if (this.monitorTreatment.status) {
          if (
            (this.monitorTreatment.status === 'Não atendida' ||
              this.monitorTreatment.status === 'Retornar para cliente' ||
              this.monitorTreatment.status === 'Em acompanhamento') &&
            !this.monitorTreatment.channel &&
            !this.monitorTreatment.date &&
            !this.monitorTreatment.time
          ) {
            swal({
              title: 'Ops!',
              text: 'Selecione os campos obrigatórios em Monitorar Tratativa',
              icon: 'error',
            });
          } else if (
            (this.monitorTreatment.status ===
              'Número pertence a outra pessoa' ||
              this.monitorTreatment.status ===
                'Impossível completar a chamada' ||
              this.monitorTreatment.status === 'Tratado' ||
              this.monitorTreatment.status === 'Finalizado' ||
              this.monitorTreatment.status === 'Problema não resolvido') &&
            this.myStatus !== 'respondido'
          ) {
            swal({
              title: 'Atenção!',
              text: 'É necessário alterar o status para "Respondido"',
              icon: 'error',
            });
          } else {
            await api.patch(
              `${process.env.API_ROOT}/treatments/update-separeted-status/${this.answerId}`,
              this.monitorTreatment,
              {
                headers: { 'x-access-token': this.userAuth.token },
              },
            );

            this.setCostumerNotifications({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
              answerId: this.answer._id,
            });

            this.monitorTreatment = {
              channel: 'Telefone',
              status: null,
              attempts: null,
              date: null,
              time: null,
            };

            swal({
              title: 'Atualizado!',
              text: 'A tratativa foi atualizada com sucesso',
              icon: 'success',
            });

            this.reloadAnswer();
          }
        }
      } else {
        swal({
          title: 'Não foi possível salvar',
          text:
            'Para salvar uma tratativa você precisa fazer alguma alteração nela.',
          icon: 'error',
        });
      }
    },
    async loadTreatment() {
      this.notAnswers = false;
      this.loading = true;
      this.viewType = 'answer';
      this.answer = null;
      this.myResponsible = null;
      this.myStatus = null;
      this.schedulingDate = null;
      this.myComment = null;
      this.allAnswers = [];

      const response = await api.get(
        `${process.env.API_ROOT}/treatments/priority`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );
      if (response && response.data && response.data.answerId) {
        this.answerId = response.data.answerId;
        if (response.data.schedulingDate) {
          this.schedulingDate = response.data.schedulingDate;
        }
        if (response.data.rule) {
          this.currentRule = response.data.rule;
        }

        const resp = await api.get(
          `${process.env.API_ROOT}/answer/${this.userAuth.companyId}/${this.answerId}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );
        this.answer = resp.data;
        this.myResponsible = this.answer.treatments.responsible;
        this.myStatus = this.answer.treatments.status;
        this.myMetric = 'nps-0-10';
        if (this.answer.metric.includes('0-10')) {
          this.promotersGrades = [10, 9];
          this.passivesGrades = [8, 7];
          this.detractorsGrades = [6, 5, 4, 3, 2, 1, 0];
        }
        if (this.answer.metric === 'like-dislike') {
          this.promotersGrades = [1];
          this.detractorsGrades = [0];
        }

        this.setCostumerNotifications({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.answer._id,
        });

        // this.startTimer();

        this.getAnswers();
      } else {
        const nextResponse = await api.get(
          `${process.env.API_ROOT}/treatments/next-scheduling`,
          {
            headers: { 'x-access-token': this.userAuth.token },
          },
        );
        if (nextResponse && nextResponse.data.schedulingDate) {
          this.notAnswers = true;
          this.nextSchedulingDate = nextResponse.data.schedulingDate;
        } else {
          this.notAnswers = true;
          this.nextSchedulingDate = null;
        }
      }
      this.loading = false;
    },
    checkName(anonymous, name) {
      if (
        anonymous &&
        !this.userProfile.permissions.answers.anonymous_profile
      ) {
        return 'Anônimo';
      } else if (this.userProfile.permissions.answers.anonymous_profile) {
        return 'Nome: ***************';
      } else if (name) {
        return name;
      }
      return 'Sem nome';
    },

    checkUserData(anonymous, profile, value) {
      if (anonymous || profile) {
        return '***************';
      } else if (value) {
        return value;
      }
      return '-';
    },
    gradeFormat(grade) {
      if (this.myMetric === 'nps-0-10') {
        if (grade >= 9 && grade <= 10) {
          return 'promoters';
        } else if (grade === 7 || grade === 8) {
          return 'neutral';
        } else if (grade < 7) {
          return 'detractors';
        }

        return 'invalid';
      } else if (this.myMetric.indexOf('1-5') > -1) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      } else if (this.myMetric.indexOf('stars') > -1) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      } else if (this.myMetric === 'like-dislike') {
        if (grade === 1) {
          return 'promoters';
        } else if (grade === 0) {
          return 'detractors';
        }
        return 'invalid';
      }

      return 'invalid';
    },
    dateFormat(param) {
      if (param) {
        const day = lightFormat(new Date(param), 'dd/MM/yyyy');
        const hour = lightFormat(new Date(param), 'HH:mm');
        return `${day} às ${hour}`;
      }

      return null;
    },
    indicatorAnonymous(actionId, anonymous, column, indicator, indicatorId) {
      let anonymousIndicator = false;
      this.indicatorsAction.forEach((el) => {
        if (el.actionId === actionId._id && el._id === indicatorId) {
          if (el.anonymous) {
            anonymousIndicator = true;
          } else {
            anonymousIndicator = false;
          }
          for (let idx = 0; idx < el.types.length; idx += 1) {
            if (el.types[idx] === 'anonymous' || el.types[idx] === 'clientId') {
              anonymousIndicator = true;
              break;
            }
          }
        }
        // return `${column}: ${indicator}`;
      });
      if (
        anonymous ||
        this.userProfile.permissions.answers.anonymous_profile ||
        anonymousIndicator
      ) {
        if (this.answer.ih1) {
          this.branches.branches.forEach((el) => {
            if (el._id === this.answer.ih1) {
              this.ih1Value = el.corporate_name;
            }
          });

          // in anonymous case it returns only the value of ih1
          if (indicator === this.ih1Value) {
            return `${column}: ${this.ih1Value}`;
          }
        }
        if (anonymous && anonymousIndicator) {
          return `${column}: **`;
        }

        if (anonymousIndicator && this.userProfile.permissions.answers.anonymous_profile) {
          return `${column}: **`;
        }

        return `${column}: ${indicator}`;
      } else if (indicator) {
        return `${column}: ${indicator}`;
      }
      return `${column}: ${indicator}`;
    },
    async getIndicators() {
      const indicators = await api.get(
        `/indicator/${this.answer.actionId._id}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            answerForm: true,
          },
        },
      );

      this.indicatorsAction = indicators.data;
    },
    async getAllBranches() {
      this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

      const response = await api.get(
        `treatments/branches/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );

      this.branches = response.data;
    },
    indicatorValuedQuestion(item) {
      if (item.indicatorValueEnabled) {
        for (let i = 0; i < this.answer.indicators.length; i += 1) {
          if (item.indicatorCriterion === 'equal') {
            if (
              this.answer.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.answer.indicators[i].value.toLowerCase() ===
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'different') {
            if (
              this.answer.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.answer.indicators[i].value.toLowerCase() !==
                item.indicatorValue.toLowerCase()
              ) {
                return true;
              }
              break;
            }
          } else if (item.indicatorCriterion === 'contains') {
            if (
              this.answer.indicators[i].column.toLowerCase() ===
              item.selectedIndicator.toLowerCase()
            ) {
              if (
                this.answer.indicators[i].value && this.answer.indicators[i].value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '') // remove accents
                  .toLowerCase()
                  .includes(
                    item.indicatorValue
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .toLowerCase(),
                  )
              ) {
                return true;
              }
              break;
            }
          }
        }
        return false;
      }
      return true;
    },
    conditionalQuestion() {
      if (this.promotersGrades.includes(this.answer.review)) {
        return 'promotor';
      } else if (this.detractorsGrades.includes(this.answer.review)) {
        return 'detrator';
      }

      return 'neutro';
    },
    formatSentiment(score) {
      let label = '';
      if (score < 0) {
        label = this.$t('answers.answersDetails.negative');
      } else if (score >= 0.6) {
        label = this.$t('answers.answersDetails.positive');
      } else {
        label = this.$t('answers.answersDetails.neutral');
      }
      return label;
    },

    formatScore(score) {
      let myScore = (score * 100).toFixed(0);
      if (score >= 0) {
        myScore = `+${myScore}`;
      }
      return myScore;
    },
    getSentiment(score) {
      let sentiment = '';
      if (score < 0) {
        sentiment = 'negative';
      } else if (score >= 0.6) {
        sentiment = 'positive';
      } else {
        sentiment = 'neutral';
      }
      return sentiment;
    },
    getFirstName(isAnonymous, fullName) {
      if (this.userProfile.permissions.answers.menu) {
        if (
          isAnonymous &&
          !this.userProfile.permissions.answers.anonymous_profile
        ) {
          return 'Anônimo';
        } else if (this.userProfile.permissions.answers.anonymous_profile) {
          return '**************';
        } else if (fullName) {
          let firstName = '';

          for (let i = 0; i < fullName.length; i += 1) {
            if (fullName[i] !== ' ') {
              firstName += fullName[i];
            } else {
              return firstName;
            }
          }
          return firstName;
        }
        return '';
      }
      return '';
    },
    async setCostumerTimeline() {
      this.loadingTimeline = true;
      if (this.answerId) {
        const response = await api.get(
          `/treatments/timeline/${this.answerId}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
              ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
              clientId: this.answer.clientId,
              email: this.answer.email,
              phone: this.answer.phone,
            },
          },
        );

        this.items = [];

        response.data.forEach((el) => {
          if (!el.anonymousResponse) {
            this.items.push({
              tag: !this.answer.anonymousResponse
                ? this.dateFormat(el.date)
                : '*******',
              content: el,
              type: 'circle',
              color: this.getColor(el.review),
            });
          }
        });
        this.loadingTimeline = false;
      }
    },
    getColor(review) {
      if (this.myMetric === 'nps-0-10') {
        if (review > 8) {
          return 'green';
        } else if (review === 7 || review === 8) {
          return 'yellow';
        }
        return 'red';
      } else if (this.myMetric === 'nps-1-5') {
        if (review > 3) {
          return 'green';
        } else if (review === 3) {
          return 'yellow';
        }
        return 'red';
      }

      return null;
    },
    disableStatus() {
      let profile = null;

      for (let i = 0; i < this.profiles.length; i += 1) {
        if (this.profiles[i]._id === this.userAuth.profileId) {
          profile = this.profiles[i].name;
        }
      }

      if (
        this.myStatus === 'respondido' &&
        profile !== 'Admin' &&
        !this.userProfile.permissions.treatments.statusClosed
      ) {
        return true;
      }

      return false;
    },
    changeResponsible() {
      this.updateResponsible({
        token: this.userAuth.token,
        answerId: this.answer._id,
        data: { responsible: this.myResponsible },
      }).then(() => {
        if (this.userAuth._id !== this.myResponsible) {
          swal({
            title: this.$t(
              'answers.answersDetails.treatments.swResponsible.title',
            ),
            text: this.$t(
              'answers.answersDetails.treatments.swResponsible.description',
            ),
            icon: 'success',
          });
        }

        this.answer.treatments.responsible = this.myResponsible;

        this.setCostumerNotifications({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.answer._id,
        });
      });
    },
    async changeStatus() {
      // if (this.myComment) {
      //   this.addNewComment();
      // }

      if (this.answer.actionId.resurveyId && this.myStatus === 'respondido') {
        const response = await api.get(
          `/resurvey/${this.answer.actionId.resurveyId}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        const hasResurvey = response.data.resurveyGrades.findIndex(
          (el) => el.grade === this.answer.review && el.value === true,
        );

        if (hasResurvey >= 0) {
          if (this.answer.anonymousResponse !== true) {
            // mercedes
            if (
              this.userAuth.companyId === '5e18ccd0dc36a60022491bdf' ||
              this.userAuth.companyId === '61965aa04be7ea63c8f83435'
            ) {
              if (this.contactClient === 'true') {
                swal({
                  title: this.$t('treatments.resurveyWarning.title'),
                  text: this.$t('treatments.resurveyWarning.description'),
                  icon: 'warning',
                  buttons: [
                    this.$t('treatments.resurveyWarning.cancelButton'),
                    this.$t('treatments.resurveyWarning.saveButton'),
                  ],
                  dangerMode: true,
                }).then(async (yes) => {
                  if (yes) {
                    await this.updateStatusProcess(this.myComment);
                  } else {
                    this.myStatus = this.answer.treatments.status;
                  }
                });
              } else {
                await this.updateStatusProcess(this.myComment);
              }
            } else {
              swal({
                title: this.$t('treatments.resurveyWarning.title'),
                text: this.$t('treatments.resurveyWarning.description'),
                icon: 'warning',
                buttons: [
                  this.$t('treatments.resurveyWarning.cancelButton'),
                  this.$t('treatments.resurveyWarning.saveButton'),
                ],
                dangerMode: true,
              }).then(async (yes) => {
                if (yes) {
                  await this.updateStatusProcess(this.myComment);
                } else {
                  this.myStatus = this.answer.treatments.status;
                }
              });
            }
          } else {
            await this.updateStatusProcess(this.myComment);
          }
        } else {
          await this.updateStatusProcess(this.myComment);
        }
      } else {
        await this.updateStatusProcess(this.myComment);
      }
    },
    async updateStatusProcess(comment) {
      try {
        if (this.isSinqia) {
          await this.updateStatusSinqia({
            token: this.userAuth.token,
            answerId: this.answer._id,
            data: { status: this.myStatus, type: this.userType, comment },
          });
        } else {
          await this.updateStatus({
            token: this.userAuth.token,
            answerId: this.answer._id,
            data: { status: this.myStatus, type: this.userType },
          });
          this.reloadAnswer();
        }

        if (comment) {
          swal({
            title: 'Sucesso!',
            text: `Seu status foi alterado para ${this.myStatus}! Seu comentário e status foram registrados no feed.`,
            icon: 'success',
          });
        } else {
          swal({
            title: this.$t('answers.answersDetails.treatments.swStatus.title'),
            text: `${this.$t(
              'answers.answersDetails.treatments.swStatus.description',
            )} ${this.myStatus}.`,
            icon: 'success',
          });
        }

        this.setCostumerNotifications({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.answer._id,
        });
      } catch (error) {
        if (this.isSinqia) {
          this.myStatus = this.answer.treatments.status;
          swal('Oops!', error.response.data.message, 'error');
        } else {
          swal('Oops!', this.$t('genericMessages.error.description'), 'error');
        }
      }
    },
    async getStatus() {
      const response = await api.get('/treatments/status', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          lang: this.$i18n.locale,
        },
      });

      this.status = response.data;
    },
    async getAnswerTag() {
      try {
        const response = await api.get('/tags-dropdown', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            tagGroup: this.tagGroupId,
          },
        });

        this.answerTags = response.data;
        this.options = this.answerTags;

        this.options.forEach((element) => {
          element.displaySubTags = false;
          element.subTags = [];
          element.loading = false;
        });
      } catch (error) {
        window.console.log(error);
      }
    },

    removeFile(index) {
      this.filesToUpload.splice(index, 1);
    },
    async getUsersAction() {
      const response = await api.get(
        `/users-action/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.answer.actionId._id,
            answerId: this.answer._id,
          },
        },
      );

      response.data.listUsers.map((el) => {
        if (el.treatmentsResponsible || el.treatmentsResponsible === null) {
          this.users.push({
            value: el._id,
            text: el.name,
          });
        }
      });

      const res = await api.get(`company/${this.userAuth.companyId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.enabledAttach = res.data.enableAttachTreatments || false;
    },

    async addNewComment() {
      if (this.myComment || this.filesToUpload.length) {
        try {
          if (this.filesToUpload) {
            if (
              this.filesToUpload.filter((item) => item.size > 10000000).length
            ) {
              swal({
                title: this.$t(
                  'answers.answersDetails.treatments.swAddError.title',
                ),
                text:
                  'Um ou mais arquivos excedem o limite. O tamanho máximo permitido é 10Mb',
                icon: 'error',
              });
              this.$refs.fileupload.reset();
            } else {
              this.isLoading = true;

              const fileLinks = [];

              // eslint-disable-next-line no-restricted-syntax
              for (const file of this.filesToUpload) {
                const formData = new FormData();
                formData.append('file', file);
                // eslint-disable-next-line no-await-in-loop
                const link = await api.post(
                  'treatments/attachments',
                  formData,
                  {
                    headers: {
                      'x-access-token': this.userAuth.token,
                      'Content-Type': 'multipart/form-data',
                    },
                  },
                );
                fileLinks.push(link.data);
              }

              this.isLoading = false;
              await this.addComment({
                token: this.userAuth.token,
                answerId: this.answer._id,
                data: {
                  comment: this.myComment || '',
                  attachments: fileLinks,
                },
              });
              swal({
                title: this.$t('answers.answersDetails.treatments.swAdd.title'),
                text: this.$t(
                  'answers.answersDetails.treatments.swAdd.description',
                ),
                icon: 'success',
              });
              this.setCostumerNotifications({
                token: this.userAuth.token,
                companyId: this.userAuth.companyId,
                answerId: this.answer._id,
              });
              this.filesToUpload = [];
            }
          } else if (this.myComment && this.myComment !== '') {
            await this.addComment({
              token: this.userAuth.token,
              answerId: this.answer._id,
              data: { comment: this.myComment },
            });
            swal({
              title: this.$t('answers.answersDetails.treatments.swAdd.title'),
              text: this.$t(
                'answers.answersDetails.treatments.swAdd.description',
              ),
              icon: 'success',
            });
            this.setCostumerNotifications({
              token: this.userAuth.token,
              companyId: this.userAuth.companyId,
              answerId: this.answer._id,
            });
          }
        } catch (error) {
          swal({
            title: this.$t(
              'answers.answersDetails.treatments.swAddError.title',
            ),
            text: this.$t(
              'answers.answersDetails.treatments.swAddError.description',
            ),
            icon: 'error',
          });
        }
      }

      this.myComment = null;
    },

    async saveAdditionalFields() {
      try {
        await api.put(
          `treatments/additional-fields/${this.answer._id}`,
          {
            additionalFields: this.additionalFields,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        swal({
          title: this.$t('answers.answersDetails.treatments.swSave.title'),
          text: this.$t('answers.answersDetails.treatments.swSave.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('answers.answersDetails.treatments.swAddError.title'),
          text: error.response.data.message,
          icon: 'error',
        });
      }
    },
    async getProfiles() {
      const response = await api.get(
        `/profiles/treatments/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      response.data.forEach((el) => {
        this.profiles.push({ _id: el._id, name: el.name, type: el.type });
      });

      for (let i = 0; i < this.profiles.length; i += 1) {
        if (this.profiles[i]._id === this.userAuth.profileId) {
          this.userType = this.profiles[i].type;
        }
      }
    },
    async getAnswers() {
      if (this.answer.anonymousResponse !== true) {
        this.toEmail = this.answer.email;
      }

      const response = await api.get(`/email-treatments/${this.answer._id}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.allAnswers = response.data;

      for (let i = 0; i < this.allAnswers.length; i += 1) {
        const message = new DOMParser().parseFromString(
          this.allAnswers[i].message.text,
          'text/html',
        );

        const textContent = message.documentElement.innerHTML;

        this.allAnswers[i].message.text = textContent;

        this.allAnswers[i].date = format(
          new Date(this.allAnswers[i].date),
          'dd/MM/yyyy HH:mm',
        );
      }
    },
    handleTemplateSelected() {
      const template = this.templateOptions.find(
        (el) => el.value === this.templateSelected,
      );
      this.emailText = template.html;
      this.emailSubject = template.subject;
    },
    async imagesUploadHandlerBody(blobInfo, success, failure) {
      if (!blobInfo) {
        return;
      }

      try {
        const formData = new FormData();

        formData.append('file', blobInfo.blob(), blobInfo.filename());

        const response = await api.post(
          '/close-the-loop/image-body',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'x-access-token': this.userAuth.token,
            },
          },
        );

        success(response.data);
      } catch (error) {
        failure(error);
      }
    },
    async updateTemplate() {
      await api.put(
        'template-treatment',
        {
          idTemplate: this.templateSelected,
          html: this.emailText,
        },
        { headers: { 'x-access-token': this.userAuth.token } },
      );

      this.getTemplates(true);

      swal({
        title: 'Template atualizado',
        text: 'Seu template foi alterado com sucesso!',
        icon: 'success',
        buttons: 'Ok',
      });
    },

    async handleSaveTemplate() {
      if (!this.emailSubject || !this.emailSender || !this.newTemplateName) {
        swal(
          'Oops...',
          this.$t('closetheloop.configureTemplate.saveErrorDescription'),
          'error',
        );
        return;
      }

      const response = await api.post(
        '/close-the-loop/templates',
        {
          name: this.newTemplateName,
          subject: this.emailSubject,
          sender: this.emailSender,
          html: this.emailText,
        },
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );

      swal(
        this.$t('closetheloop.configureTemplate.templatedCreatedTitle'),
        this.$t('closetheloop.configureTemplate.templatedCreatedDescription'),
        'success',
      );

      this.templateOptions.push({
        value: response.data._id,
        text: response.data.name,
        subject: response.data.subject,
        sender: response.data.sender,
        html: response.data.html,
      });

      this.templateSelected = response.data._id;

      this.templateNameSelected = response.data.name;

      this.newTemplateName = null;
    },

    async getTemplates(updateSelect) {
      const response = await api.get('/treatments/templates', {
        headers: { 'x-access-token': this.userAuth.token },
      });

      if (updateSelect) {
        this.templateOptions = [];
      }

      this.templateOptions.push({
        value: null,
        text: this.$t('closetheloop.configureTemplate.selectTemplate'),
        subject: null,
        sender: null,
        html: null,
      });

      response.data.forEach((el) => {
        this.templateOptions.push({
          value: el._id,
          text: el.name,
          subject: el.subject,
          sender: el.sender,
          html: el.html,
          type: el.type,
        });
      });
    },

    async refresh() {
      this.getAnswers();
    },

    async replyEmail() {
      this.toEmail = this.answer.email;

      this.historicMessage = this.allAnswers[0].message.html;
      this.emailSubject = this.allAnswers[0].message.subject;

      this.historicFrom =
        '<p style="font-size: 14px;" class="h5 mb-0"><strong>De</strong>:' +
        `${this.allAnswers[0].message.from}` +
        '</p>';

      this.historicTo =
        '<p style="font-size: 14px;" class="h5 mb-0"><strong>Para</strong>:' +
        `${this.allAnswers[0].message.to}` +
        '</p>';

      this.historicSubject =
        '<p style="font-size: 14px;" class="h5 mb-0"><strong>Assunto</strong>:' +
        `${this.allAnswers[0].message.subject}` +
        '</p>';

      this.historicDate =
        '<p style="font-size: 14px;" class="h5 mb-0"><strong>Assunto</strong>:' +
        `${this.allAnswers[0].date}` +
        '</p>';

      this.historicDate =
        '<p style="font-size: 14px;" class="small text-gray"><i class="fa fa-clock-o mr-1"></i>' +
        `${this.allAnswers[0].date}` +
        '</p>';

      const hr = '<br /><br /><br /><br /><br /><br /><hr />';

      this.historicMessage =
        hr +
        this.historicFrom +
        this.historicTo +
        this.historicSubject +
        this.historicDate +
        this.historicMessage;

      this.emailText = this.historicMessage;
    },

    async sendMail() {
      if (!this.userProfile.permissions.answers.anonymous_profile) {
        if (this.answer.treatments.responsible === 'none') {
          EventBus.$emit('changeResponsible', this.userAuth._id);

          this.updateResponsible({
            token: this.userAuth.token,
            answerId: this.answer._id,
            data: { responsible: this.userAuth._id },
          });
        }

        await api.post(
          `/email-treatments/${this.answer._id}`,
          {
            emailText: this.emailText,
            emailTo: this.toEmail,
            emailSubject: this.emailSubject,
            from: this.emailSender
              ? this.emailSender
              : this.$store.state.companies.company.name,
            headers: { 'x-access-token': this.userAuth.token },
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        // swal({
        //   title: 'E-mail enviado com sucesso!',
        //   icon: 'success',
        // });

        swal({
          title: 'Tratativa enviada',
          text: 'Envio registrado no feed!',
          icon: 'success',
          buttons: 'Ok',
          className: 'customSwal',
        }).then(() => {
          // get next treatment
        });

        // limpar campos após enviar email
        this.emailText = '';
        this.emailTo = '';
        this.toEmail = '';
        this.emailSender = this.$store.state.companies.company.name;

        this.templateSelected = this.templateOptions[0].value;
        this.templateNameSelected = null;

        await this.setCostumerNotifications({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          answerId: this.answer._id,
        });

        this.getAnswers();
      } else {
        swal({
          title: 'Seu perfil está no modo anônimo!',
          icon: 'warning',
        });
      }
    },

    async handleRemoveTag(tagId, tagIndex) {
      swal({
        title: 'Remover Tag',
        text: 'Tem certeza que deseja remover essa tag?',
        icon: 'warning',
        buttons: [this.$t('answers.cancel'), this.$t('answers.remove')],
        dangerMode: true,
      }).then(async (deleted) => {
        if (deleted) {
          swal('Tag removida com sucesso!', {
            icon: 'success',
          });
          this.answer.tags.splice(tagIndex, 1);
          const subTags = [];
          this.answer.subTags.forEach((el) => {
            if (el.mainTagId !== tagId) {
              subTags.push(el);
            }
          });
          this.answer.subTags = subTags;
          await api.patch(
            `/answer-tags/${this.answer._id}`,
            {
              operation: 'delete',
              tagId,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
        }
      });
    },

    async handleRemoveSubTag(tagId, subTagId, subTagIndex) {
      this.answer.subTags.splice(subTagIndex, 1);

      await api.patch(
        `/tag-subtag/${this.answer._id}`,
        {
          subTagId,
          tagId,
          operation: 'delete',
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async handleRemoveCategory(categoryId, categoryIndex) {
      swal({
        title: this.$t('answers.deleteCategory.title'),
        text: this.$t('answers.deleteCategory.description'),
        icon: 'warning',
        buttons: [this.$t('answers.cancel'), this.$t('answers.remove')],
        dangerMode: true,
      }).then(async (deleted) => {
        if (deleted) {
          swal(this.$t('answers.categoryDelSuccess'), {
            icon: 'success',
          });
          this.answer.categories.splice(categoryIndex, 1);
          const subCategories = [];
          this.answer.subCategories.forEach((el) => {
            if (el.mainCategoryId !== categoryId) {
              subCategories.push(el);
            }
          });
          this.answer.subCategories = subCategories;
          await api.patch(
            `/answer-categories/${this.answer._id}`,
            {
              operation: 'delete',
              categoryId,
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
        }
      });
    },

    async handleRemoveSubCategory(categoryId, subCategoryId, subCategoryIndex) {
      this.answer.subCategories.splice(subCategoryIndex, 1);

      await api.patch(
        `/category-subcategory/${this.answer._id}`,
        {
          subCategoryId,
          categoryId,
          operation: 'delete',
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  async beforeRouteLeave (to, from, next) {

    if(this.answerId){
      if(this.statusSaved){
      return next();
      }
      const confirm = await this.$bvModal.msgBoxConfirm('Ao sair desta página página, o cliente voltará para a fila. Você quer mesmo sair?', {
        title: 'Atenção!',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        okVariant: 'danger',
        footerClass: 'p-2',
        centered: true
      });
      if (!confirm) {
        return false
      }
      api.put(`/treatments/disable-treatment/${this.answerId}`, {
        callWorking:false
      },
      {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      })
  };

  return next();

},
  async mounted() {
    // await this.getIndicators();

    await this.loadTreatment();
    if (!this.answerId) return;

    this.getAllBranches();
    this.getIndicators();
    // this.setCostumerTimeline();

    this.getProfiles();

    await this.getStatus();

    this.myStatus = this.answer.treatments.status;

    this.getUsersAction();

    this.getAnswerTag();

    this.myResponsible = this.answer.treatments.responsible
      ? this.answer.treatments.responsible
      : 'none';

    EventBus.$on('changeResponsible', (value) => {
      this.myResponsible = value;
    });

    this.getAllUsers({
      userId: this.userAuth._id,
      companyId: this.userAuth.companyId,
      token: this.userAuth.token,
      params: {
        ih1: this.answer.ih1,
        ih2: this.answer.ih2,
      },
    });

    this.setCostumerNotifications({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
      answerId: this.answer._id,
    });

    this.emailSender = this.$store.state.companies.company.name;
    this.getAnswers();
    this.getTemplates();

    if (this.answer.anonymousResponse === true) {
      this.habilitFields = true;
    }

    if (this.answer.additionalFields) {
      if (this.answer.additionalFields.length > 0) {
        this.additionalFields = this.answer.additionalFields;
      }
    }

    if (this.answer.contactClient) {
      this.contactClient = this.answer.contactClient;
    }

    if (this.answer.contactMode) {
      this.contactMode = this.answer.contactMode;
    }

    if (this.contactClient === false) {
      this.disabledContactMode = true;
    } else {
      this.disabledContactMode = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper {
  padding: 8px;
}

.page-header {
  h3 {
    font-size: 20px;
    margin: 0;
  }

  p {
    font-size: 18px;
  }
}

.refresh-icon {
  cursor: pointer;
  color: $primary;

  &:hover {
    color: rgb(97, 209, 97);
  }
}

.body {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
}

.body-content {
  border: 1px solid $gray-light;
  border-radius: 4px;

  .header {
    background-color: $white;
    display: flex;
    justify-items: center;
    height: 70px;
    padding-top: 8px;
  }

  .content {
    background-color: #e6e6e6;
    padding: 16px;
  }
}

.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 12px;
  color: $gray;
}

.input-area {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  select {
    max-width: 300px;
  }
}

.card-header {
  padding: 0.75rem 1.25rem;
  background-color: white;

  h5 {
    font-size: 16px;
  }
}

.card-content {
  p {
    color: #888383;
    font-size: 14px;
  }
}

.textarea {
  border: solid 1px #e3e3e3;
  border-radius: 4px;
  padding: 8px;
  min-height: 80px;
}

.timeline-textarea {
  border: solid 1px #e3e3e3;
  border-radius: 4px;
  padding: 8px;
  min-height: 60px;
}

.custom-primary {
  background: #ffffff;
}

.custom-primary:hover {
  color: $primary;
  background: #f8f8f8;
}

.flag-grade {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  text-align: center;
  justify-content: center;
  padding-top: 11px;
  color: #ffffff;
}

.flag-grade-promoters {
  background-color: #28a745;
}

.flag-grade-detractors {
  background-color: #dc3545;
}

.flag-grade-neutral {
  background-color: rgb(211, 211, 17);
}

.flag-grade-invalid {
  background-color: #c1c1c1;
}

.flag-sentiment {
  padding: 8px 10px;
  font-size: 16px;
  color: white;
  border-radius: 20px;
}

.flag-sentiment-negative {
  background-color: #dc3545;
}

.flag-sentiment-neutral {
  background-color: rgb(211, 211, 17);
}

.flag-sentiment-positive {
  background-color: #28a745;
}

.time-line {
  .card-body {
    flex: 1 1 auto;
    padding: 1.25rem;
  }

  .vertical-timeline {
    width: 100%;
    position: relative;
    padding: 1.5rem 0 1rem;
  }

  .vertical-timeline::before {
    content: '';
    position: absolute;
    top: 0;
    left: 27px;
    height: 100%;
    width: 4px;
    background: #e9ecef;
    border-radius: 0.25rem;
  }

  .vertical-timeline-element {
    position: relative;
    margin: 0 0 1rem;
  }

  .vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
    visibility: visible;
    animation: cd-bounce-1 0.8s;
  }

  .vertical-timeline-element-icon {
    position: absolute;
    top: 0;
    left: 20px;
  }

  .vertical-timeline-element-icon .badge-dot-xl {
    box-shadow: 0 0 0 5px #fff;
  }

  .badge-dot-xl {
    width: 18px;
    height: 18px;
    position: relative;
  }

  .badge:empty {
    display: none;
  }

  .badge-dot-xl::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 0.25rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -5px 0 0 -5px;
    background: #fff;
  }

  .vertical-timeline-element-content {
    position: relative;
    margin-left: 60px;
    font-size: 0.8rem;
  }

  .vertical-timeline-element-content .timeline-title {
    font-size: 0.8rem;
    text-transform: uppercase;
    margin: 0 0 0.5rem;
    padding: 2px 0 0;
    font-weight: bold;
  }

  .vertical-timeline-element-content .vertical-timeline-element-date {
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    padding-right: 10px;
    text-align: right;
    color: #adb5bd;
    font-size: 0.7619rem;
    white-space: nowrap;
  }

  .vertical-timeline-element-content:after {
    content: '';
    display: table;
    clear: both;
  }
}

ul.timeline {
  list-style-type: none;
  position: relative;
  padding-left: 1.5rem;
}

ul.timeline:before {
  content: ' ';
  background: #e8e8e8;
  display: inline-block;
  position: absolute;
  left: 16px;
  width: 4px;
  height: 100%;
  z-index: 400;
  border-radius: 1rem;
}

li.timeline-item {
  margin: 20px 0;
}

.timeline-arrow {
  border-top: 0.5rem solid transparent;
  border-right: 0.5rem solid #fff;
  border-bottom: 0.5rem solid transparent;
  display: block;
  position: absolute;
  left: 2rem;
}

li.timeline-item::before {
  content: ' ';
  background: #ddd;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  left: 11px;
  width: 14px;
  height: 14px;
  z-index: 400;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.position-share {
  text-align: right;
}

.input-category {
  min-height: 52px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 7px 12px;
  cursor: pointer;
  b-badge: {
    color: #ffffff;
  }
}

.closebtn {
  margin-left: 8px;
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
.btn {
  box-shadow: none !important;
}

#card-content-format{
  width: 57rem
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/treatments/separated-treatments/index.vue